import generatedMaps from "../generated/maps.generated.json" with { type: "json" };
import type {
  MapDefinition,
  MapRuntimeDefinition,
  MapVisualDefinition,
} from "./MapDefinition.js";

export type {
  MapDefinition,
  MapRuntimeDefinition,
  MapVisualDefinition,
} from "./MapDefinition.js";

export const MAP_DEFINITIONS: Readonly<Record<string, MapRuntimeDefinition>> =
  generatedMaps.maps as Record<string, MapRuntimeDefinition>;
export const OUTER_FOREST = MAP_DEFINITIONS["outer_forest"]!;
export const OUTER_FOREST_MVP = MAP_DEFINITIONS["outer-forest-mvp"]!;
export const FRONTIER_CANYON = MAP_DEFINITIONS.frontier_canyon!;
export const BLACK_FORGE_RANGE_FLOORS = [
  MAP_DEFINITIONS.black_forge_range!,
  MAP_DEFINITIONS.black_forge_range_2!,
  MAP_DEFINITIONS.black_forge_range_3!,
];

export const DEFAULT_MAP_ID = OUTER_FOREST.id;
export const DEFAULT_PVP_MAP_ID = OUTER_FOREST_MVP.id;

const loadedMapVisuals = new Map<string, Promise<MapDefinition>>();

export function getMapDefinition(
  mapId: string | undefined,
): MapRuntimeDefinition | undefined {
  return mapId ? MAP_DEFINITIONS[mapId] : undefined;
}

export function loadMapDefinition(
  mapId: string | undefined,
): Promise<MapDefinition | undefined> {
  const metadata = getMapDefinition(mapId);
  if (!metadata) return Promise.resolve(undefined);

  const cached = loadedMapVisuals.get(metadata.id);
  if (cached) return cached;

  const load = fetch(`/assets/maps/${encodeURIComponent(metadata.id)}.visual.json`)
    .then(async (response) => {
      if (!response.ok)
        throw new Error(
          `Could not load map visuals for ${metadata.id} (HTTP ${response.status}).`,
        );
      const visuals = (await response.json()) as MapVisualDefinition;
      if (
        visuals.mapId !== metadata.id ||
        visuals.mapRevision !== metadata.revision
      )
        throw new Error(
          `Map visual revision mismatch for ${metadata.id}: expected ${metadata.revision}, received ${visuals.mapRevision}.`,
        );
      return { ...metadata, ...visuals };
    })
    .catch((error: unknown) => {
      loadedMapVisuals.delete(metadata.id);
      throw error;
    });
  loadedMapVisuals.set(metadata.id, load);
  return load;
}
